/**
 * @deprecated
 * use COLORS from src/tokens/colors instead
 */
export const COLORS: Record<string, string> = {
    black: '#1A1A1A',
    darkGrey: '#656565',
    middleGray: '#979797',
    grey: '#CECECE',
    outlineGrey: '#EBEBEB',
    lightGrey: '#F7F7F7',
    white: '#FFFFFF',
    blue: '#007AE5',
    lightBlue: '#7ABCFF',
    red: '#FF2323',
    lightRed: '#FC7474',
    lightPink: '#FCDCDC',
    yellow: '#FFD400',
    lightYellow: '#FFE200',
    green: '#14944A',
    lightGreen: '#27AE60',
    GRAY_DARK: '#181B21',
    GRAY_XL: '#393C41',
    GRAY_L: '#5C5E62',
    GRAY_M: '#74767A',
    GRAY_S: '#C5C6C7',
    GRAY_XS: '#EEEEEF',
    GRAY_XXS: '#F5F5F5',
    GRAY_LIGHT: '#FAFAFA',
    RED_FIRM: '#E30813',
    RED_LIGHT: '#FAF3F4',
    RED_ERROR: '#FF5962',
    RED_ERROR_LIGHT: '#FDEEEE',
    RED_GRADIENT: 'linear-gradient(179.99deg, #E30813 0.01%, #BE241E 99.99%)',
    RED_WHITE_GRADIENT: 'radial-gradient(100% 161.09% at 100% 0%, rgba(227, 8, 19, 0.15) 0%, rgba(227, 8, 19, 0) 100%), #FFFFFF',
    RED_TRANSPARENT_GRADIENT: 'radial-gradient(100% 161.09% at 100% 0%, rgba(227, 8, 19, 0.15) 0%, rgba(227, 8, 19, 0) 100%)',
};

/**
 * @deprecated
 * use FONTS from src/tokens/fonts.ts instead
 */
export enum FONTS {
    H0 = 'font: var(--bold-h0); letter-spacing: -0.03em;',
    H1 = 'font: var(--bold-h1); letter-spacing: -0.03em;',
    H2 = 'font: var(--bold-h2);',
    H3 = 'font: var(--bold-h3);',
    H4 = 'font: var(--bold-h4);',
    H5 = 'font: var(--bold-h5);',
    H6 = 'font: var(--bold-h6);',
    Medium = 'font: var(--medium);',
    XXL = 'font: var(--regular-xxl); letter-spacing: -0.01em;',
    XL = 'font: var(--regular-xl); letter-spacing: -0.01em;',
    L = 'font: var(--regular-l);',
    M = 'font: var(--regular-m);',
    S = 'font: var(--regular-s);',
    XS = 'font: var(--regular-xs);',
    XXS = 'font: var(--regular-xxs);',
}

export const layoutIndent = 32;

type TBreakpoint = Record<string, Record<string, string>>;

export const BREAKPOINTS: TBreakpoint   = {
    default: {
        '320': '767px',
        '768': '1023px',
        '1024': '1279px',
        '1366': '1599px',
    },
    wide: {
        '320': '767px',
        '768': '1023px',
        '1024': '1365px',
        '1366': '1649px',
    },
};

/**
 * Layout breakpoints
 * @param {(number|string)} media - алиас макета
 * @param {string} mode - тип грида
 * @return {string}
 */
export function breakPoint(media: number | string, mode = 'default'): string {
    switch (media.toString()) {
        case '1366':
            return `max-width: ${BREAKPOINTS[mode]['1366']}`;
        case '1024':
            return `max-width: ${BREAKPOINTS[mode]['1024']}`;
        case '768':
            return `max-width: ${BREAKPOINTS[mode]['768']}`;
        case '320':
            return `max-width: ${BREAKPOINTS[mode]['320']}`;
        default:
            return 'max-width: auto';
    }
}
